import api from "@/api/apiConfig"
import {
  Post,
  Get
} from './base/baseAjax'
let addPost = (param) => {
  return Post({
    url: api.organize.addPost,
    bodyParam: param
  })
}
let editPost = (param) => {
  return Post({
    url: api.organize.editPost,
    bodyParam: param
  })
}
let removePost = (param) => {
  return Post({
    url: api.organize.removePost,
    bodyParam: param
  })
}
let addDepart = (param) => {
  return Post({
    url: api.organize.addDepart,
    bodyParam: param
  })
}
let editDepart = (param) => {
  return Post({
    url: api.organize.editDepart,
    bodyParam: param
  })
}
let removeDepart = (param) => {
  return Get({
    url: api.organize.removeDepart,
    PathParam: param
  })
}
let moveDepart = (param) => {
  return Post({
    url: api.organize.moveDepart,
    bodyParam: param
  })
}
let setLeader = (param) => {
  return Post({
    url: api.organize.setLeader,
    UrlParam: param
  })
}
let getPostByDepartId = (param) => {
  return Post({
    url: api.organize.getPostByDepartId,
    bodyParam: param
  })
}

export default {
  addPost,
  editPost,
  removePost,
  addDepart,
  editDepart,
  removeDepart,
  setLeader,
  getPostByDepartId,
  moveDepart
}



// WEBPACK FOOTER //
// ./src/services/organize.js